export default [
  {
    header: 'Transaksi',
    resource: 'Transaction',
    action: 'read',
  },
  {
    title: 'Pesanan',
    route: 'transactions',
    icon: 'ShoppingBagIcon',
    resource: 'Transaction',
    action: 'read',
  },
  {
    title: 'Pesanan',
    route: 'transactions-v2',
    icon: 'ShoppingBagIcon',
    resource: 'TransactionV2',
    action: 'read',
  },

  {
    header: 'Obrolan',
    resource: 'Chat',
    action: 'read',
  },
  {
    title: 'Chat (Mia)',
    route: 'chat',
    icon: 'MessageSquareIcon',
    resource: 'Chat',
    action: 'read',
  },
  {
    title: 'Feedback',
    route: 'chat-feedback',
    icon: 'UserIcon',
    resource: 'Chat',
    action: 'read',
  },

  {
    header: 'Promosi',
    resource: 'Sale',
    action: 'read',
  },
  {
    title: 'Banner',
    route: 'banners',
    resource: 'Banner',
    action: 'read',
    icon: 'ImageIcon',
  },
  {
    title: 'Banner',
    route: 'banners-v2',
    resource: 'BannerV2',
    action: 'read',
    icon: 'ImageIcon',
  },
  {
    title: 'Voucher',
    route: 'vouchers',
    resource: 'Voucher',
    action: 'read',
    icon: 'PercentIcon',
  },
  {
    title: 'Voucher',
    route: 'vouchers-v2',
    icon: 'PercentIcon',
    resource: 'VoucherV2',
    action: 'read',
  },
  {
    title: 'Koleksi',
    route: 'collections',
    icon: 'GridIcon',
    resource: 'Collection',
    action: 'read',
  },
  {
    title: 'Notifikasi',
    route: 'notifications',
    resource: 'Notification',
    action: 'read',
    icon: 'BellIcon',
  },
  {
    title: 'Sale',
    route: 'sale',
    resource: 'Sale',
    action: 'read',
    icon: 'TagIcon',
  },

  {
    header: 'Barang',
    resource: 'Product',
    action: 'read',
  },
  {
    title: 'Produk',
    route: 'products',
    icon: 'ArchiveIcon',
    resource: 'Product',
    action: 'read',
  },
  {
    title: 'Approval',
    route: 'unverified',
    icon: 'CheckSquareIcon',
    resource: 'ProductApproval',
    action: 'read',
  },
  {
    title: 'Kategori',
    route: 'categories',
    icon: 'BoxIcon',
    resource: 'Category',
    action: 'read',
  },

  {
    title: 'Kategori',
    route: 'categories-v2',
    icon: 'BoxIcon',
    resource: 'CategoryV2',
    action: 'read',
  },

  {
    header: 'Pengguna',
    resource: 'User',
    action: 'read',
  },
  {
    title: 'Pembeli',
    route: 'users',
    icon: 'UserIcon',
    resource: 'User',
    action: 'read',
  },
  {
    title: 'Pembeli',
    route: 'users-v2',
    icon: 'UserIcon',
    resource: 'UserV2',
    action: 'read',
  },
  {
    title: 'Brand',
    route: 'brands',
    icon: 'AwardIcon',
    resource: 'Merchant',
    action: 'read',
  },
  {
    title: 'Brand',
    route: 'brands-v2',
    icon: 'AwardIcon',
    resource: 'MerchantV2',
    action: 'read',
  },
  {
    title: 'Affiliator',
    route: 'affiliate',
    icon: 'UsersIcon',
    resource: 'Affiliate',
    action: 'read',
  },

  {
    header: 'Lainnya',
    resource: 'Faq',
    action: 'read',
  },
  {
    title: 'FAQ',
    icon: 'MessageCircleIcon',
    children: [
      {
        title: 'Daftar FAQ',
        route: 'faq',
        resource: 'Faq',
        action: 'read',
      },
      {
        title: 'Kategori FAQ',
        route: 'faq-categories',
        resource: 'FaqCategory',
        action: 'read',
      },
    ],
  },

  {
    title: 'Artikel',
    icon: 'BookOpenIcon',
    children: [
      {
        title: 'Daftar Artikel',
        route: 'articles',
        resource: 'Article',
        action: 'read',
      },
      {
        title: 'Kategori Artikel',
        route: 'article-categories',
        resource: 'FaqCategory',
        action: 'read',
      },
    ],
  },
  {
    title: 'Review',
    route: 'reviews',
    icon: 'StarIcon',
    resource: 'Review',
    action: 'read',
  },

  {
    header: 'Laporan',
    resource: 'DashboardRegistry',
    action: 'read',
  },
  {
    title: 'Bulanan ',
    route: 'dashboard-recapt',
    resource: 'DashboardMonthly',
    icon: 'CalendarIcon',
    action: 'read',
  },
  {
    title: 'Produk ',
    route: 'dashboard-product',
    resource: 'DashboardProduct',
    icon: 'ArchiveIcon',
    action: 'read',
  },
  {
    title: 'Registry ',
    route: 'dashboard-registry',
    resource: 'DashboardRegistry',
    icon: 'GiftIcon',
    action: 'read',
  },
  {
    title: 'Brand ',
    route: 'dashboard-brand',
    resource: 'DashboardBrand',
    icon: 'AwardIcon',
    action: 'read',
  },

  {
    header: 'Pengaturan',
    resource: 'Setting',
    action: 'read',
  },
  {
    title: 'Pengaturan ',
    route: 'settings',
    icon: 'SettingsIcon',
    resource: 'Setting',
    action: 'read',
  },

  // Super Admin
  {
    header: 'Manajemen Admin',
    resource: 'AdministratorV2',
    action: 'read',
  },
  {
    title: 'Administrator',
    route: 'administrators-v2',
    icon: 'ShieldIcon',
    resource: 'AdministratorV2',
    action: 'read',
  },
  {
    title: 'Hak Akses',
    icon: 'LockIcon',
    children: [
      {
        title: 'Permissions',
        route: 'permissions',
        resource: 'Permission',
        action: 'read',
      },
      {
        title: 'Roles',
        route: 'roles',
        resource: 'Role',
        action: 'read',
      },
    ],
  },
  {
    title: 'Metode Pembayaran',
    route: 'payment-methods',
    icon: 'CreditCardIcon',
    resource: 'PaymentMethod',
    action: 'read',
  },
  {
    title: 'Layanan Kurir',
    route: 'courier-services',
    icon: 'TruckIcon',
    resource: 'CourierService',
    action: 'read',
  },
]
